import "lazysizes";
import PhotoSwipe from "photoswipe";
import PhotoSwipeUI_Default from "photoswipe/dist/photoswipe-ui-default";
import "slick-carousel";
import "slick-carousel/slick/slick.scss";
import "slick-carousel/slick/slick-theme.scss";
import SVGInjector from "svg-injector-2";

import "photoswipe/dist/photoswipe.css";
import "photoswipe/dist/default-skin/default-skin.css";
import "saleor/scss/photoswipe-override.scss";

export const getAjaxError = response => {
  let ajaxError = $.parseJSON(response.responseText).error.quantity;
  return ajaxError;
};
export const csrftoken = $.cookie("csrftoken");

export default $(document).ready(e => {
  function csrfSafeMethod(method) {
    return /^(GET|HEAD|OPTIONS|TRACE)$/.test(method);
  }

  new SVGInjector().inject(document.querySelectorAll("svg[data-src]"));

  // Wait to load the product video until it's in view on the bootstrap carousel
  $("#carousel-example-generic").on('slide.bs.carousel', function (e) {
    const item = e.relatedTarget;
    const video = item.querySelector('video');
    if (video) {
      const url = video.getAttribute('data-url');
      video.setAttribute('data-src', url);
      video.querySelector('source').setAttribute('src', url);
      video.load();
    }
  });

  // For related products carousel
  $('.slick-carousel').on('init', function(event, slick){
    /*
    In related_products_carousel.html, the carousel wrapper limits the height to a specific height
    in pixels to prevent it from being too tall while waiting for the images to load. After the
    carousel is initialized, this listener unsets the heigh so that it will be adaptive to the
    screen width.
    */
    const related = document.getElementsByClassName('related-carousel-wrapper');
    if(related !== undefined && related.length > 0){
      for(const element of related) {
        element.style.height = 'unset';
      }
    } else {
      console.warn("There is no 'related-carousel-wrapper' on this slick-carousel.")
    }
  });
  $(".slick-carousel").each(function () {
    $(this).slick({
      infinite: true,
      slidesToShow: 3,
      slidesToScroll: 1,
      prevArrow: "#slick-arrow-prev",
      nextArrow: "#slick-arrow-next",
      responsive: [
        {
          breakpoint: 800,
          settings: {
            infinite: true,
            slidesToShow: 2,
            slidesToScroll: 1
          }
        }
      ]
    });
  });

  // For sizing video popup
  $(".photoswipe-sizing-video").each(function () {
    var pswpElement = document.querySelectorAll(".pswp")[0];
    var gallery = $(this);
    var items = [];

    items = items.concat(
      gallery
        .find(".photoswipe-vid")
        .map(function () {
          var child = $(this);

          return {
            html: `<div class="video-wrapper"><video class="d-block img-fluid lazyload lazypreload photoswipe-vid" alt="sizing video" autoplay><source src="${child.data("url")}" type="video/mp4"></video></div>`,
          };
        })
        .get()
    );

    gallery.find(".size-chart-link.link").on("click", function () {
      var item = $(this);
      var options = {
        shareEl: false,
        index: item.data("index"),
        closeOnScroll: false,
      };
      var gallery = new PhotoSwipe(
        pswpElement,
        PhotoSwipeUI_Default,
        items,
        options
      );

      gallery.listen('close', function() {
        if ($('.photoswipe-vid').length > 0) {
          $('.photoswipe-vid')[0].pause();
          $('.photoswipe-vid')[0].src = "";
        }
      });

      gallery.init();
    });
  });

  // For product image modal gallery thing
  $(".photoswipe-gallery").each(function () {
    var pswpElement = document.querySelectorAll(".pswp")[0];
    var gallery = $(this);
    var items = [];

    items = items.concat(
      gallery
        .find(".photoswipe-src")
        .map(function () {
          var child = $(this);

          if (child.hasClass('video')) {
            return {
              html: `<div class="video-wrapper"><video class="d-block img-fluid lazyload lazypreload photoswipe-src video" alt="product video" autoplay loop muted><source src="${child.data("url")}" type="video/mp4"></video></div>`,
              isVideo: true,
            };
          }

          return {
            mediumImage: {
              src: child.data("src-med"),
              w: child.data("w-med"),
              h: child.data("h-med")
            },
            originalImage: {
              src: child.data("src-lrg"),
              w: child.data("w-lrg"),
              h: child.data("h-lrg")
            }
          };
        })
        .get()
    );

    gallery.find(".photoswipe-target").on("click", function () {
      var item = $(this);
      var options = {
        fullscreenEl: false,
        shareEl: false,
        index: item.data("index")
      };
      var gallery = new PhotoSwipe(
        pswpElement,
        PhotoSwipeUI_Default,
        items,
        options
      );

      var realViewportWidth,
        useLargeImages = false,
        firstResize = true,
        imageSrcWillChange;
      // beforeResize event fires each time size of gallery viewport updates
      gallery.listen("beforeResize", function () {
        // calculate real pixels when size changes
        realViewportWidth = gallery.viewportSize.x * window.devicePixelRatio;
        // Code below is needed if you want image to switch dynamically on window.resize
        // Find out if current images need to be changed
        if (useLargeImages && realViewportWidth < 1000) {
          useLargeImages = false;
          imageSrcWillChange = true;
        } else if (!useLargeImages && realViewportWidth >= 1000) {
          useLargeImages = true;
          imageSrcWillChange = true;
        }
        // Invalidate items only when source is changed and when it's not the first update
        if (imageSrcWillChange && !firstResize) {
          // invalidateCurrItems sets a flag on slides that are in DOM,
          // which will force update of content (image) on window.resize.
          gallery.invalidateCurrItems();
        }
        if (firstResize) {
          firstResize = false;
        }

        imageSrcWillChange = false;
      });
      // gettingData event fires each time PhotoSwipe retrieves image source & size
      gallery.listen("gettingData", function (index, item) {
        // Set image source & size based on real viewport width
        if (!item.isVideo) {
          if (useLargeImages) {
            item.src = item.originalImage.src;
            item.w = item.originalImage.w;
            item.h = item.originalImage.h;
          } else {
            item.src = item.mediumImage.src;
            item.w = item.mediumImage.w;
            item.h = item.mediumImage.h;
          }
        }
      });

      gallery.init();
    });
  });

  $.ajaxSetup({
    beforeSend: function (xhr, settings) {
      if (!csrfSafeMethod(settings.type) && !this.crossDomain) {
        xhr.setRequestHeader("X-CSRFToken", csrftoken);
      }
    }
  });

  // Open tab from the link

  let hash = window.location.hash;
  $('.nav-tabs a[href="' + hash + '"]').tab("show");

  // Preload all images
  window.lazySizesConfig.preloadAfterLoad = true;

  // Force min and max on number inputs
  $('.enforce-minmax').on('input', e => {
    if (isNaN(Number(e.target.value))) {
      e.target.value = e.target.data['oldvalue'] || ''
    } else if (Number(e.target.value) < e.target.min) {
      e.target.value = e.target.min
    } else if (Number(e.target.value) > e.target.max) {
      e.target.value = e.target.max
    }
    $(e.target).data('oldvalue', e.target.value)
  })

  // Show elements that should only be available if js is enabled
  $('.js-show').removeClass('js-show')
});
